import { Component, OnInit, Input } from '@angular/core';
import { GeofencesService } from 'src/app/geofences/services/geofences.service';
import { configSections } from 'src/app/profile-config/services/user-config-panel.service';

@Component({
  selector: 'app-user-geofences-config',
  templateUrl: './user-geofences-config.component.html',
  styleUrls: ['./user-geofences-config.component.scss', './../components-conf.scss']
})
export class UserGeofencesConfigComponent implements OnInit {
  @Input() filterOptionsBy : string = ""

  public filterConfiguration : string = "";
  public configSections = configSections;

  constructor(
    public geofenceService : GeofencesService
  ) { }

  public options = [
    { label: 'Vista por operación', value: 'viewGroup' },
    { label: 'Vista General', value: 'viewGen' }
  ];

  ngOnInit(): void {
  }


}
